/* ============================================================
   BNE STUDIO — Midnight Blueprint icon set
   Ported 1:1 from the design handoff (chrome.js ICON map).
   Every glyph is a single 24x24 stroked path on currentColor.
   ============================================================ */
import React from "react";

// d = path data, w = stroke width (defaults to 2)
const PATHS = {
  chev: { d: "M6 9l6 6 6-6", w: 2.2 },
  dist: { d: "M12 3v12m0 0l-4-4m4 4l4-4M5 21h14" },
  contracts: {
    d: "M14 3v4a1 1 0 0 0 1 1h4M18 21H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8l6 6v3M8 18c1.4-2 2.8-2 4 0s2.6 2 4 0",
  },
  sync: { d: "M4 6a2 2 0 012-2h4l2 2.5h6a2 2 0 012 2V18a2 2 0 01-2 2H6a2 2 0 01-2-2z" },
  vision: {
    d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3ZM3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z",
  },
  live: {
    d: "M4 8a2 2 0 012-2h12a2 2 0 012 2 2 2 0 000 4 2 2 0 000 4 2 2 0 01-2 2H6a2 2 0 01-2-2 2 2 0 000-4 2 2 0 000-4Z",
  },
  links: { d: "M9 15l6-6M10 6l1-1a4 4 0 016 6l-1 1M14 18l-1 1a4 4 0 01-6-6l1-1" },
  stem: { d: "M12 2 2 7l10 5 10-5-10-5ZM2 12l10 5 10-5M2 17l10 5 10-5" },
  mix: { d: "M21 11.5a8.4 8.4 0 0 1-12.8 7.2L3 21l2.3-5.2A8.4 8.4 0 1 1 21 11.5ZM9 11v2M12 9v6M15 11v2" },
  suite: { d: "M7 2h10a1 1 0 011 1v18a1 1 0 01-1 1H7a1 1 0 01-1-1V3a1 1 0 011-1zM10 18h4" },
  lyrics: { d: "M4 6h16M4 12h16M4 18h10" },
  bpm: { d: "M12 3 4 19h16L12 3ZM12 11v4" },
  pitch: { d: "M4 14h3l3-8 4 16 3-8h3" },
  tools: { d: "M5 12h14M5 12l4-4M5 12l4 4" },
  ext: { d: "M7 17L17 7M9 7h8v8" },
};

export function NightIcon({ name }) {
  if (name === "logo") {
    return (
      <img src="/brand/bne/bne-studio-logo-03-transparent-light.png" alt="" />
    );
  }

  const p = PATHS[name];
  if (!p) return null;
  return (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d={p.d}
        stroke="currentColor"
        strokeWidth={p.w || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NightIcon;
